// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__+CLI9","primary":"Button_primary__V9B0D"};